import { useEffect } from 'react'
import { useUser } from '@clerk/clerk-react'

// TYPES
import { IoTClient } from './config'
import { Topic, TopicListener } from './types'


export const useIoTClient = <T extends Topic>(...[topic, callback, settings]: Parameters<TopicListener<T>>) => {
    const { id: userId } = useUser().user || {}
    useEffect(() => {
        if (!!userId) {
            const iotClient = IoTClient.getInstance(userId)
            iotClient.addTopicListener(topic, callback, settings)
            return () => { iotClient.removeTopicListener(topic, callback, settings) }
        }
    }, [userId])
}